export default __webpack_public_path__ + "static/media/login_background.ebcb9160.svg";